/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StateTown } from './StateTown';
import {
    StateTownFromJSON,
    StateTownFromJSONTyped,
    StateTownToJSON,
    StateTownToJSONTyped,
} from './StateTown';

/**
 * 
 * @export
 * @interface FindAllStateTownsResponse
 */
export interface FindAllStateTownsResponse {
    /**
     * 
     */
    data: Array<StateTown>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllStateTownsResponse interface.
 */
export function instanceOfFindAllStateTownsResponse(value: object): value is FindAllStateTownsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllStateTownsResponseFromJSON(json: any): FindAllStateTownsResponse {
    return FindAllStateTownsResponseFromJSONTyped(json, false);
}

export function FindAllStateTownsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllStateTownsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(StateTownFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllStateTownsResponseToJSON(json: any): FindAllStateTownsResponse {
    return FindAllStateTownsResponseToJSONTyped(json, false);
}

export function FindAllStateTownsResponseToJSONTyped(value?: FindAllStateTownsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(StateTownToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

